/**
 * L_GLOBAL_CONTACT_PROFILE.SERVICE_ADDR_JSON_DATA / BUSINESS_ADDR_JSON_DATA
 * (백엔드 extractAddressArrayFromProfileJsonColumn 과 동일 규칙)
 */
export function extractAddressArrayFromProfileJsonColumn(
    raw: unknown,
    wrapperKey: 'service_address' | 'business_address'
): Record<string, unknown>[] {
    if (raw == null || raw === '') return [];
    try {
        const obj = typeof raw === 'string' ? JSON.parse(raw as string) : (raw as Record<string, unknown>);
        if (!obj || typeof obj !== 'object') return [];
        if (Array.isArray(obj)) {
            return obj
                .filter((x) => x && typeof x === 'object')
                .map((x) => ({ ...(x as object) } as Record<string, unknown>));
        }
        const wrapped = obj[wrapperKey as keyof typeof obj];
        if (Array.isArray(wrapped)) {
            return wrapped
                .filter((x) => x && typeof x === 'object')
                .map((x) => ({ ...(x as object) } as Record<string, unknown>));
        }
        if (wrapped && typeof wrapped === 'object') {
            return [{ ...(wrapped as object) }];
        }
        const o = obj as Record<string, unknown>;
        if (
            o.street01 != null ||
            o.street1 != null ||
            o.country != null ||
            o.post_code != null ||
            o.postcode != null
        ) {
            return [{ ...o }];
        }
        return [];
    } catch {
        return [];
    }
}
